// @flow
import { RegistrosActionTypes } from './constants';

type RegistrosAction = { type: string, payload: {} | string };

// common success
export const registrosApiResponseSuccess = (actionType: string, data: any): RegistrosAction => ({
    type: RegistrosActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const registrosApiResponseError = (actionType: string, error: string): RegistrosAction => ({
    type: RegistrosActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const addRegistro = (registro:any):RegistrosAction=>({
    type:RegistrosActionTypes.ADD_REGISTRO,
    payload:registro
})

export const listRegistros = (params:any): RegistrosAction => ({
    type: RegistrosActionTypes.LIST_REGISTROS,
    payload: params,
});

export const getRegistrosForExcel = (params:any): RegistrosAction => ({
    type: RegistrosActionTypes.GET_REGISTROS_FOR_EXCEL,
    payload: params,
});

export const getRegistrosForExcelRA = (params:any): RegistrosAction => ({
    type: RegistrosActionTypes.GET_REGISTROS_FOR_EXCEL_RA,
    payload: params,
});

export const getRegistrosItSendStat = (params:any): RegistrosAction => ({
    type: RegistrosActionTypes.GET_REGISTROS_IT_SEND_STAT,
    payload: params,
});

export const getDataCharts = (params:any): RegistrosAction => ({
    type: RegistrosActionTypes.GET_DATA_CHARTS,
    payload: params,
});

export const getDataChartsComparisons = (params:any): RegistrosAction => ({
    type: RegistrosActionTypes.GET_DATA_CHARTS_COMPARISONS,
    payload: params,
});

export const resetRegistros = (): RegistrosAction => ({
    type: RegistrosActionTypes.RESET,
    payload: {},
});

export const resetAllRegistros = (): RegistrosAction => ({
    type: RegistrosActionTypes.RESET_ALL,
    payload: {},
});


